import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';

export const actionTypes = {
  VALIDATION_ERRORS_GET_FAILURE: 'VALIDATION_ERRORS_GET_FAILURE',
  VALIDATION_ERRORS_GET_REQUEST: 'VALIDATION_ERRORS_GET_REQUEST',
  VALIDATION_ERRORS_GET_SUCCESS: 'VALIDATION_ERRORS_GET_SUCCESS',
};

export const actionCreators = {
  getRequest: (uploadId: string, token: string) => ({
    type: actionTypes.VALIDATION_ERRORS_GET_REQUEST,
    payload: { token, uploadId },
    [WAIT_FOR_ACTION]: actionTypes.VALIDATION_ERRORS_GET_SUCCESS,
    [ERROR_ACTION]: actionTypes.VALIDATION_ERRORS_GET_FAILURE,
  }),
  getSuccess: (validationErrors: Array<any>) => ({
    type: actionTypes.VALIDATION_ERRORS_GET_SUCCESS,
    payload: { validationErrors },
  }),
  getFailure: (error: Error) => ({
    type: actionTypes.VALIDATION_ERRORS_GET_FAILURE,
    error,
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
